var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-link"},[_vm._v(_vm._s(_vm.dimension.nombre))])
}
var staticRenderFns = []

export { render, staticRenderFns }